import React from "react";
import ResearchOverviewSkeleton from "./ResearchOverviewSkeleton";
import ResearchExpandCard from "../ResearchExpandCard/ResearchExpandCard";
import { Paragraph } from "../../Commons/Paragraph";
import RightArrow from "../../../assets/imgs/arrow-right.svg";
import EyeWhiteIcon from "../../../assets/imgs/player_profile_chat.svg";
import TeamIcon from "../../../assets/imgs/team-icon.svg";
import FeaturePlayersCard from "../../Home/FeaturePlayersCard/FeaturePlayersCard";
import { actions } from "../../../Redux/store";

interface Insight {
  BlurbTitle: string;
  ExtendedBlurb?: string;
  LastProccessedTime?: string;
  BlurbTrend?: string;
}

interface InsightsOverview {
  seasonRecap?: Insight;
  seasonOutlook?: Insight;
  weeklyRecap?: Insight;
  weeklyOutlook?: Insight;
}

const ResearchOverview: React.FC<{
  data: {
    latestNews?: {
      suggestedQuestions: any;
      recapsOutlooks?: InsightsOverview;
    };
    similarPlayers?: any;
  };
  setSimilarPlayerId?: (id: string | null) => void;
  playerProfileLoading?: boolean;
}> = ({ data, setSimilarPlayerId, playerProfileLoading }) => {
  const insights = data?.latestNews?.recapsOutlooks;

  const handlePlayerClick = async (playerId: string) => {
    if (setSimilarPlayerId) {
      setSimilarPlayerId(playerId);
    }
  };

  if (playerProfileLoading) {
    return <ResearchOverviewSkeleton />;
  }

  return (
    <>
      <div className="mt-5 flex flex-col items-center">
        {insights ? (
          Object.entries(insights).map(([key, value], index) => {
            if (value && typeof value === "object" && "BlurbTitle" in value) {
              return (
                <div
                  key={key}
                  className={`${index === 2 ? "order-1" : "order-2"} border-b-[1px] border-[#ffffff33] pb-4`}
                >
                  <ResearchExpandCard
                    title={value.BlurbTitle}
                    subTitle={key}
                    plus={value.BlurbTrend === "+"}
                    description={
                      value.ExtendedBlurb || "No additional details available"
                    }
                    date={value.LastProccessedTime || "N/A"}
                  />
                </div>
              );
            }
            return null;
          })
        ) : (
          <div className="text-[22px] text-white/50 font-medium flex justify-center">-- No Data --</div>
        )}
      </div>

      <div className="mt-7 pb-5">
        <div className="flex items-center text-white mb-4 sm:mb-5 md:mb-6 lg:mb-7">
          <img src={TeamIcon} alt="TeamIcon" className="w-5" />
          <h3 className="text-base sm:text-3xl md:text-4xl lg:text-[45.393px] font-semibold ml-2">
            Similar Players
          </h3>
        </div>
        {data?.similarPlayers && data.similarPlayers.length > 0 ? (
          data.similarPlayers.map((player: any, index: number) => (
            <div
              className={`flex flex-col -ml-3  ${index !== data.similarPlayers.length - 1 && "border-b-[0.6px]"} border-[#ffffff33] `}
              key={index}
              onClick={() => {
                handlePlayerClick(player?.roto_player_id);
              }}
            >
              <FeaturePlayersCard
                playerSmallIcon={player.player_headshot_url}
                playerName={player.name}
                playerPosition={player.orig_position}
                playerStatus={player.player_team}
                bgColor={player.player_team_short}
                cardBg={false}
              />
            </div>
          ))
        ) : (
          <div className="text-[22px] text-white/50 font-medium flex justify-center">-- No Data --</div>
        )}
      </div>
    </>
  );
};

export default ResearchOverview;
